import React from 'react'
import './reporte.css'
import fetch from 'node-fetch'
import moment from 'moment'

import { verifyAuth, getToken } from '../Commons/Authentication'

import NavigationBar from '../Commons/NavigationBar'
class Reporte extends React.Component {
  constructor(props) {
    super(props)
    this.state = ({
      filesData: [],
      fileSelected: '',
      reporte: true,
      epsList: [],
      prestaciones: [],
      time1: '01-01-2018',
      time2: '01-01-2019',
      tomas: 0,
      asegurador: '',
      programas: '',
      prestacion: ''
    })
    this.fetchEps()
    this.fetchPrestaciones()
    this.fetchFiles()
    window.logued = verifyAuth()
    this.Form1 = this.Form1.bind(this)
    this.Tabs = this.Tabs.bind(this)
    // this.onClickInput = this.onClickInput.bind(this)
  }
  programas() {
    let original = [
      { name: '' }, 
      { _id: '5cec58a60631573619d54a65', name: 'Sin Programa' }, 
      { _id: '5cec58e00631573619d54a83', name: 'Saludables'}
    ]
    let options = original.map((d) => {
      return <option>{d.name}</option>
    })
    return (<select onChange={this.funcionCambiar.bind(this)} className='controllers' id='programas'>{options}</select>)
  }
  findActividad() {
    let findData = () => {
      request
        .get('api/v1/agendamiento/')
        .query({ name: this.refs.prestacion.value })
        .set('Authorization', `Bearer ${getToken()}`)
        .set('Accept', 'application/json')
        .end((err, res) => {
          this.setState({ dataActivity: res.body })
        })
    }
    setTimeout(findData, 500)
    this.setState({
      dirty: true,
      prestacion: this.refs.prestacion.value
    })
  }
  uploadFile(e) {
    let formData = new FormData()
    formData.append('file', e.target.files[0])

    let headers = {
      'Authorization': `Bearer ${getToken()}`
    }
    const url = 'api/v1/file/'
    let uploadResponse = fetch(url, {
      headers,
      method: 'POST',
      body: formData
    }).then(response => response.json())

    uploadResponse.then((response) => {
      // console.log(response)
      this.fetchFiles()
    })
  }

  funcionCambiarCSV(e){
    const { id, value, type } = e.target
    this.setState({ fileSelected: id })
    console.log("Seleted file: "+ id)
  }

  funcionCambiar(e) {
    const { id, value, type } = e.target
    // const state = this.state
    let date = ''
    if (type === 'date') {
      date = moment(value, 'YYYY-MM-DD').format('DD-MM-YYYY')
      let objState = {}
      objState[id] = date
      this.setState(objState)
    }
    if (type === 'select-one') {
      let objState = {}
      objState[id] = value
      // objState = {...state, ...objState}
      console.log(objState)
      try {
        this.setState(objState)

      } catch (err) {

      }
    }
    if (type === 'radio') {
      let reporte = id === 'reporte'
      this.setState(state => ({ ...state, reporte }))
    }
  }
  exportFunction() {
    // let e = document.getElementById('asegurador')
    // let asegurador = e.options[e.selectedIndex].text
    console.log(this.state)
    const { time1, time2, tomas, asegurador, programas, reporte } = this.state
    let { prestacion } = this.state

    let headers = {
      'Authorization': `Bearer ${getToken()}`,
      'Content-Type': 'text/csv'
    }
    // let asegurador = 'EPS Sura'

    //prestacion = ''

    let url = `/api/v1/export/filters/relations=[paciente,estadoDeSaludData]?time1=${time1}&time2=${time2}&asegurador=${asegurador}&prestacion=${prestacion}&tomas=${tomas}&programa=${programas}`
    // console.log(reporte, idexcel)
    if (!reporte) {
      try {
        let idexcel = ''
        let m = document.getElementsByClassName('input-radio-files') // input-all
        for (var i = 0; i < m.length; i++) {
          /*if (m[i].checked) {
            idexcel = m[i].id
          }*/
          if( this.state.fileSelected === m[i].id ){
            m[i].checked = true
            idexcel = this.state.fileSelected
          }
        }
        url = `/api/v1/export/filters/relations=[paciente,estadoDeSaludData]?time1=${time1}&time2=${time2}&asegurador=${asegurador}&prestacion=${prestacion}&tomas=${tomas}&programa=${programas}&file=${idexcel}`
      } catch (err) {
        console.log(err)
      }
    }
    const getBlob = fetch(url, { headers })
      .then(response => response.blob())

    getBlob.then((data) => {
      console.log(data)
      try {
        var csvURL = window.URL.createObjectURL(data)
        let tempLink = document.createElement('a')
        tempLink.href = csvURL
        tempLink.setAttribute('download', `pacientes_${moment().format('DDMMYYYYHHmm')}.csv`)
        tempLink.click()
      } catch (err) {
        console.log(err)
      }
    })
  }
  fetchPrestaciones() {
    let headers = {
      'Authorization': `Bearer ${getToken()}`,
      'Content-Type': 'application/json'
    }
    const url = 'api/v1/agendamiento/all'
    let prestaciones = fetch(url, { headers })
      .then(response => response.json())

    prestaciones.then((response) => {
      //   console.log(response)
      this.setState({ prestaciones: response })
    })
  }
  fetchEps() {
    let headers = {
      'Authorization': `Bearer ${getToken()}`,
      'Content-Type': 'application/json'
    }
    const url = 'api/v1/eps/'
    let eps = fetch(url, { headers })
      .then(response => response.json())
    eps.then((response) => {
      this.setState({ epsList: response })
    })
  }
  tomas() {
    let options = []
    for (let i = 0; i < 7; i++) {
      options.push(<option key={`${i}t`}>{(i === 0) ? '' : i}</option>)
    }
    return (<select onChange={this.funcionCambiar.bind(this)} className='controllers' id='tomas'>{options}</select>)
  }
  entidades() {
    let { epsList } = this.state
    epsList = [{ nombre: '' }, ...epsList]
    if (epsList.length <= 0) {
      return
    }
    let arr = epsList

    let options = arr.map((entidad) => {
      const { nombre } = entidad
      return <option>{nombre}</option>
    })
    return (<select onChange={this.funcionCambiar.bind(this)} className='controllers' id='asegurador'>{options}</select>)
  }
  prestaciones() {
    let { prestaciones } = this.state
    prestaciones = [{ '_id': '', 'name': '' }, ...prestaciones]
    // console.log(prestaciones)
    if (prestaciones.length <= 0) {
      return
    }
    let arr = prestaciones

    let options = arr.map((prestaciones) => {
      const { name } = prestaciones
      return <option>{name}</option>
    })
    return (<select onChange={this.funcionCambiar.bind(this)} className='controllers' id='prestacion'>{options}</select>)
  }
  fetchFiles() {
    let headers = {
      'Authorization': `Bearer ${getToken()}`,
      'Content-Type': 'application/json'
    }
    const url = 'api/v1/file/'
    let file = fetch(url, { headers })
      .then(response => response.json())
    file.then((response) => {
      this.setState({ filesData: response })
    })
  }
  // onClickInput(e) {
  //   console.log('e target', e.target.id)
  //   let idexcel_ = e.target.id
  //   this.setState(state => ({ ...state, idexcel: idexcel_ }))
  //   // this.setState({  })
  // }
  files() {
    const { filesData } = this.state
    console.log("Archivos...", filesData)
    return filesData.map((file, id) => {
      let key = `${id}_1`
      let inputkey = `${Math.random()}im`
      let labelkey = `${Math.random()}im`
      let date = moment(file.timestamp, 'x').format('DD-MM-YYYY HH:mm:ss')
      //console.log("Archivos.. x2:", filesData)
      /*let m = document.getElementsByClassName('input-radio-files') // input-all
      for (var i = 0; i < m.length; i++) {
        if( this.state.fileSelected === m[i].id ){
          console.log("entra y checked", m[i])
          m[i].checked = true
        }
      }*/

      return (
        <div className="file-content" key={key}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <input className="input-radio-files" 
           onChange={this.funcionCambiarCSV.bind(this)}
           checked={ this.state.fileSelected === file._id }
            id={file._id} key={inputkey} 
            type="radio" name="file" />
          <label className="label-all" key={labelkey}>{file.name}</label>
          <div className="date-all">{file.creadoPor} <span className="date">{date} </span></div>
        </div>)
    })
  }
  Tabs() {
    let form1 = this.state.reporte
    let classNameTab = 'tabs'
    if (!form1) {
      classNameTab = 'columgridhead tabs'
    }
    return (
      <div className={classNameTab}>
        <div className="tab-imform">
          <div className="informes-button selected" >
            <input id="reporte" onChange={this.funcionCambiar.bind(this)} name="interfaz" type="radio" checked={this.state.reporte}></input> <label> Reporte general </label>
          </div>
        </div>
        <div className="tab-inform">
          <div className="informes-button" >
            <input id="cedulas" onChange={this.funcionCambiar.bind(this)} name="interfaz" type="radio" checked={!this.state.reporte}></input> <label> Filtrar cédulas </label>
          </div>
        </div>
      </div>
    )
  }

  Form1() {
    let form1 = this.state.reporte
    let classNameCol = 'colm-2'
    let classNameGeneral = 'general'
    if (!form1) {
      classNameCol = 'columgridcolum2'
      classNameGeneral = 'twoColums general'
    }
    return (
      <div className="reporte-normal">
        <div className={classNameGeneral}>
          <this.Tabs></this.Tabs>

          {!form1
            ? (<div className="columgridcolum1">
              <div>
                <div className="number">1</div>Anexa un archivo o elige uno del historial
              </div>

              <div>
                <div>Historial de archivos
                  <div className="upload-btn-wrapper">
                    <button className="btn">Anexar documento</button>
                    <input onChange={this.uploadFile.bind(this)} className="file" type="file"></input>
                  </div>
                  </div>
                <div className="scrollControl">
                  {this.files()}
                </div>

              </div>
            </div>)
            : null}
          <div className={classNameCol}>
            {!form1
              ? (<div><div className="number">2</div>Elige los filtros necesarios para generar el informe</div>)
              : null}
            <div className="form-field">
              <label className="griditem1">Fecha</label>
              <input onChange={this.funcionCambiar.bind(this)} className="griditem2" id='time1' type='date' />
              <input onChange={this.funcionCambiar.bind(this)} className="griditem3" id='time2' type='date' />
            </div>
            <div className="form-field">
              <label className="griditem1">Entidad</label>
              <div className="griditem4">
                {this.entidades()}
              </div>
            </div>
            <div className="form-field">
              <label className="griditem1">Programa</label>
              <div className="griditem4">
                {this.programas()}
              </div>
            </div>
            <div className="form-field">
              <label className="griditem1">Prestacion</label>
              <div className="griditem4">
                {this.prestaciones()}
              </div>
            </div>
            <div className="form-field">
              <label className="griditem1">Tomas</label>
              <div className="griditem2">
                {this.tomas()}
              </div>
            </div>
            <div className="form-field">
              <div className="griditem4">
                <div className=" button-download" onClick={this.exportFunction.bind(this)}><i className="icon-icon-57-document-download"></i> Descargar reporte </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    let verifyAuth = window.logued
    if (!verifyAuth) {
      return null
    } else {
      return (
        <div className="container-reportes">
          <NavigationBar></NavigationBar>
          <this.Form1></this.Form1>
        </div>
      )
    }
  }
}
export default Reporte



// WEBPACK FOOTER //
// ./src/components/Reportes/Reporte.js